import axiosInstance from "../axiosInstance";

export const warehouseCostRateService = {
  fetch: async (clientId, limit = 100, skip = 0, signal) => {
    let api = `/warehouse-cost-rate?$limit=${limit}&$skip=${skip}&$sort[effective_from]=-1`;
    if (clientId) {
      api += `&client_id=${clientId}`;
    }
    const response = await axiosInstance.get(api, signal ? { signal } : undefined);
    return response.data;
  },
  create: async (data) => {
    const response = await axiosInstance.post("/warehouse-cost-rate", data);
    return response.data;
  },
  edit: async (data, id) => {
    const response = await axiosInstance.patch(`/warehouse-cost-rate/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(`/warehouse-cost-rate/${id}`);
    return response.data;
  },
};
